import { PersonAddOutlined, PersonRemoveOutlined } from "@mui/icons-material";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setFriends } from "state";
import FlexBetween from "./FlexBetween";
import UserImage from "./UserImage";
import { BASE_URL } from "../config";
import { useEffect, useState } from "react";

const Friend = ({ friendId, name, subtitle, userPicturePath, hideActions = false, size = "55px" }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const _id = user?._id;
  const friends = user?.friends || [];

  const [userData, setUserData] = useState(null);

  const { palette } = useTheme();
  const primaryLight = palette.primary.light;
  const primaryDark = palette.primary.dark;
  const main = palette.neutral.main;
  const medium = palette.neutral.medium;

  const isFriend = Array.isArray(friends) && friends.find((friend) => friend._id === friendId);

  // Fetch user data if name is not provided
  useEffect(() => {
    if (!name && friendId) {
      const fetchUser = async () => {
        const headers = {};
        if (token) {
          headers.Authorization = `Bearer ${token}`;
        }
        const response = await fetch(`${BASE_URL}/users/${friendId}`, {
          method: "GET",
          headers: headers,
        });
        const data = await response.json();
        setUserData(data);
      };
      fetchUser();
    }
  }, [friendId, name, token]);

  const patchFriend = async () => {
    if (!_id || !token) return; // Prevent action if not authenticated

    const response = await fetch(
      `${BASE_URL}/users/${_id}/${friendId}`,
      {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    dispatch(setFriends({ friends: data }));
  };

  const displayName = name || (userData ? `${userData.firstName} ${userData.lastName}` : "");
  const displaySubtitle = subtitle || (userData?.location || "");
  const displayPicture = userPicturePath || (userData?.picturePath || "");

  return (
    <FlexBetween>
      <FlexBetween gap="1rem">
        <UserImage image={displayPicture} size={size} />
        <Box
          onClick={() => {
            navigate(`/profile/${friendId}`);
          }}
        >
          <Typography
            color={main}
            variant={parseInt(size) < 50 ? "subtitle2" : "h5"}
            fontWeight="500"
            sx={{
              "&:hover": {
                color: palette.primary.light,
                cursor: "pointer",
              },
            }}
          >
            {displayName}
          </Typography>
          <Typography color={medium} fontSize="0.75rem">
            {displaySubtitle}
          </Typography>
        </Box>
      </FlexBetween>
      {!hideActions && _id && _id !== friendId && (
        <IconButton
          onClick={() => patchFriend()}
          sx={{ backgroundColor: primaryLight, p: "0.6rem" }}
        >
          {isFriend ? (
            <PersonRemoveOutlined sx={{ color: primaryDark }} />
          ) : (
            <PersonAddOutlined sx={{ color: primaryDark }} />
          )}
        </IconButton>
      )}
    </FlexBetween>
  );
};

export default Friend;